import { render, staticRenderFns } from "./TestDetail.vue?vue&type=template&id=02b96ea8&scoped=true"
import script from "./TestDetail.vue?vue&type=script&lang=js"
export * from "./TestDetail.vue?vue&type=script&lang=js"
import style0 from "./TestDetail.vue?vue&type=style&index=0&id=02b96ea8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b96ea8",
  null
  
)

export default component.exports